/** Delt validering/slug for kobling-ID-er (1–63 tegn, små bokstaver/tall/bindestrek). */

export const BINDING_ID_PATTERN = /^[a-z0-9][a-z0-9-]{0,62}$/;

export const BINDING_ID_ERROR =
    'Kun små bokstaver, tall og bindestrek; må starte med bokstav/tall.';

/** Lager en gyldig kobling-ID fra et fritekstnavn (slug). */
export function toBindingId(name: string): string {
    return name
        .toLowerCase()
        .replace(/æ/g, 'ae')
        .replace(/ø/g, 'o')
        .replace(/å/g, 'a')
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 63)
        .replace(/-+$/, '');
}
